export const DEMO_LINK = 'https://demo.m4mh.app/';

export const NHS_LINK =
  'https://www.nhs.uk/every-mind-matters/urgent-support/#urgent-support';
